import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-color-code-picker',
  standalone: false,
  templateUrl: './color-code-picker.component.html',
  styleUrl: './color-code-picker.component.scss',
})
export class ColorCodePickerComponent {
  @Input() color = '#D9D9D9';
  @Input() variant: 'inline' | 'field' = 'field';
  @Input() showCaret = false;
  @Input() saveLabel = 'Save';
  @Input() defaultColor = '#D9D9D9';
  @Output() colorChange = new EventEmitter<string>();

  @ViewChild('colorPalette') colorPalette!: OverlayPanel;

  customColor = '#D9D9D9';
  showCustomPicker = false;

  presetColors: string[] = [
    '#C05476', '#D85675', '#DA5234', '#D6837A',
    '#E3683E', '#DD7835', '#E0963C', '#E7BA51',
    '#D8BE5E', '#BCC256', '#85AD59', '#55B080',
    '#489160', '#429A8E', '#4B99D2', '#668BE1',
    '#6E72C3', '#828BC2', '#AE9CCE', '#A479B1',
    '#A75ABA', '#957367', '#7C7C7C', '#A5998C',
  ];

  get displayColor(): string {
    return this.normalizeHex(this.color || this.defaultColor);
  }

  openColorPalette(event: Event) {
    this.customColor = this.displayColor;
    this.showCustomPicker = false;
    this.colorPalette?.toggle(event);
  }

  isColorSelected(color: string): boolean {
    return this.displayColor === this.normalizeHex(color);
  }

  selectPresetColor(color: string) {
    this.applyColor(color);
    this.colorPalette?.hide();
  }

  openCustomColorPicker(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.customColor = this.displayColor;
    this.showCustomPicker = true;
  }

  applyCustomColor() {
    this.applyColor(this.customColor);
    this.showCustomPicker = false;
    this.colorPalette?.hide();
  }

  onPanelHide() {
    this.showCustomPicker = false;
  }

  private applyColor(color: string) {
    const value = this.normalizeHex(color);
    this.color = value;
    this.customColor = value;
    this.colorChange.emit(value);
  }

  normalizeHex(color: string): string {
    const value = color || this.defaultColor || '#D9D9D9';
    return value.startsWith('#') ? value.toUpperCase() : `#${value}`.toUpperCase();
  }
}
